import { AccountComponent } from './account/account.component';
import { AudioFileComponent } from './audio/audio-file.component';
import { AudioService } from './audio/audio.service';
import { WavesurferComponent } from './audio-waves/wavesurfer.component.js';
import { AudioWavesComponent } from './audio-waves/audio-waves.component';
import { AudioWavesService } from './audio-waves/audio-waves.service';
import { scCoreModule } from '../core/core.module';
import './fact-thumb-list.component';
import { FactThumbComponent } from './fact-thumb.component';
import { FactSliderComponent } from './slider/facts-slider.component';
import { FactsComponent } from './facts.component';
import { FactsWidgetComponent } from './fact-widget.component';
import { FactTableRowComponent } from './fact-table-row.component';
import { FactBottomComponent } from './fact-bottom.component';
import { FactInfoComponent } from './fact-info.component';
import { ColumnResizeComponent } from './colresize';
import { HeatmapComponent } from './heatmap/heatmap.component';
import { FactsMenuComponent } from './facts-menu.component';
import { FactsSliderTimelineComponent } from './slider/facts-slider-timeline.component';
import { FactsSliderViewComponent } from './slider/facts-slider-view.component';
import { FactsTableComponent } from './facts-table.component';

export const scFactsModule = 'sc-facts';

angular.module(scFactsModule, [scCoreModule])
  .service('AudioService', AudioService)
  .service('AudioWavesService', AudioWavesService)
  .component('scAudioFile', AudioFileComponent)
  .component('scAudioWaves', AudioWavesComponent)
  .component('scAccount', AccountComponent)
  .component('scFactThumb', FactThumbComponent)
  .component('scFactSlider', FactSliderComponent)
  .directive('scWavesurfer', WavesurferComponent)
  .directive('scFacts', FactsComponent)
  .directive('scFactsTable', FactsTableComponent)
  .directive('scFactWidget', FactsWidgetComponent)
  .directive('scFactTableRow', FactTableRowComponent)
  .directive('scFactBottom', FactBottomComponent)
  .directive('scFactInfo', FactInfoComponent)
  .directive('colResize', ColumnResizeComponent)
  .directive('scHeatmap', HeatmapComponent)
  .component('scFactsMenu', FactsMenuComponent)
  .directive('scFactsSliderTimeline', FactsSliderTimelineComponent)
  .component('scFactsSliderView', FactsSliderViewComponent)

  .directive('errSrc', function () {
    return {
      link: function (scope, element, attrs) {
        element.bind('error', function () {
          element.attr('src', attrs.errSrc);
        });
      },
    };
  })

  .directive('thumbonload', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('load', function (fact) {
          const thumbId = attrs.id;
          $('#' + thumbId + '_preloader').hide();
        });
      },
    };
  })

  .directive('thumblistonload', function () {
    return {
      restrict: 'A',
      link    : function (scope, element, attrs) {
        element.bind('load', function (event) {
          const thumbId = attrs.id;
          $('#' + thumbId + '_preloader').hide();
          if ($('#facts-container').height() > $('.fact-thumbnail-list')
              .height()) {
            let parent = scope.$parent;
            while (!parent.more) {
              parent = parent.$parent;
            }
            parent.more();
          }
        });
      },
    };
  })

  .directive('thumbonerror', function () {
    return {
      restrict: 'A',
      link    : function (scope, element, attrs) {
        element.bind('error', function () {
          const thumbId = attrs.id;
          $('#' + thumbId + '_preloader').hide();
        });
      },
    };
  })

;



// WEBPACK FOOTER //
// ./src/facts/facts.module.js